module.exports = __webpack_public_path__ + "img/Andaluza-24-min.242fb50f.jpg";